/*
 * Copyright (C) 2018 - present by OpenGamma Inc. and the OpenGamma group of companies
 *
 * Please see distribution for license.
 */

import { Action } from '@ngrx/store';
import { UserDetails } from 'app/user-auth/models';

// -------------------------------------------------------------------------
// User Login
export const USER_LOGIN = '[User Auth] User Login';
export const USER_LOGIN_SUCCESS = '[User Auth] User Login Success';
export const USER_LOGIN_ERROR = '[User Auth] User Login Error';

// -------------------------------------------------------------------------
// User Login Actions
export class UserLogin implements Action {
  readonly type = USER_LOGIN;
}

export class UserLoginSuccess implements Action {
  readonly type = USER_LOGIN_SUCCESS;

  constructor(public userDetails: UserDetails) {}
}

export class UserLoginError implements Action {
  readonly type = USER_LOGIN_ERROR;

  constructor(public errorMessage: string) {}
}

// -------------------------------------------------------------------------
export type All = UserLogin | UserLoginSuccess | UserLoginError;
